import Card from '@mui/material/Card'

// Material Dashboard 2 React components
import MDBox from '../../../components/MDComponents/MDBox'
import MDTypography from '../../../components/MDComponents/MDTypography'
import MDInput from '../../../components/MDComponents/MDInput'

// Authentication layout components
import CoverLayout from '../../../layouts/authentication/components/CoverLayout'

// Images
import { NavLink } from 'react-router-dom'
import useForgotPassword from './useForgotPassword'
import Button from '../../../components/Button'

import pages from 'constants/pages'

const ForgotPassword = () => {
  const { success, input, handleChange, handleSubmit, error, isLoading } =
    useForgotPassword()
  return (
    <CoverLayout>
      <Card className="!bg-secondary-background">
        <div className="bg-btn-primary rounded-lg mx-2 p-3 mt-[-1.5rem] text-center">
          <div className="text-3xl font-medium text-over-primary mt-2">
            Recuperare parolă
          </div>
          <div className="text-over-primary text-xs mt-2">
            Completează adresa de email a contului pentru a-ți recupera parola.
          </div>
        </div>
        {success === true ? (
          <MDBox p={1} textAlign="center">
            <div className="text-xs my-2 text-over-primary-background">
              Vei primi un email cu instrucțiunile pentru recupararea parolei în
              câteva minute
            </div>
          </MDBox>
        ) : (
          <MDBox pt={4} pb={1} px={3}>
            <form>
              <MDBox component="form" role="form">
                <MDBox mb={1}>
                  <MDInput
                    type="email"
                    inputProps={{ style: { fontSize: 16 } }}
                    label="Email"
                    variant="standard"
                    fullWidth
                    value={input.email}
                    name="email"
                    onChange={handleChange}
                    error={error.err}
                  />
                </MDBox>
                {error.err && (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                  >
                    {error.textError}
                  </MDTypography>
                )}
                <MDBox mt={6} mb={1}>
                  <Button
                    onClick={handleSubmit}
                    className="w-full h-10 bg-btn-primary text-over-primary"
                    isLoading={isLoading}
                    type="submit"
                  >
                    Resetează parola
                  </Button>
                </MDBox>
              </MDBox>
            </form>
          </MDBox>
        )}
        <MDBox mb={1} textAlign="center">
          <div className="text-over-secondary-background text-sm ">
            Știi parola contului tău?{' '}
            <NavLink to={pages.auth.login} className="font-medium text-primary">
              Autentifică-te!
            </NavLink>
          </div>
          <div className="text-over-secondary-background text-sm ">
            Nu ai încă un cont?{' '}
            <NavLink
              className="font-medium text-primary"
              to={pages.auth.register}
            >
              Înregistrează-te!
            </NavLink>
          </div>
        </MDBox>
      </Card>
    </CoverLayout>
  )
}

export default ForgotPassword
